import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';

interface SimpleMapProps {
  coordinates?: number[];
  className?: string;
  width?: string;
  height?: string;
}

const SimpleMap: React.FC<SimpleMapProps> = ({ coordinates, className, width, height }) => {
  const { t } = useTranslation();
  const widthStyle = width ? width : '250px';
  const heightStyle = height ? height : '250px';

  if (!coordinates) {
    return (
      <div
        style={{
          height: height,
          width: width,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'lightgray',
        }}
        className={className}
      >
        {t('map.notAvailable')}
      </div>
    );
  }

  const position: [number, number] = [coordinates[1], coordinates[0]];

  // Custom component to trigger invalidateSize on mount
  const MapInvalidateSize = () => {
    const map = useMap();
    useEffect(() => {
      map.invalidateSize();
    }, [map]);
    return null;
  };

  return (
    <div style={{ height: heightStyle, width: widthStyle }} className={className}>
      <MapContainer
        center={position}
        zoom={13}
        scrollWheelZoom={true}
        style={{ height: '100%', width: '100%' }}
        zoomControl={false}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={position} />
        <MapInvalidateSize />
      </MapContainer>
    </div>
  );
};

export default SimpleMap;
